import * as React from 'react';

const SvgMenu = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#56565b"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="menu_svg__feather menu_svg__feather-menu"
    {...props}
  >
    <path d="M3 12h18M3 6h18M3 18h18" />
  </svg>
);

export default SvgMenu;
